import React from 'react';
import { Box, Typography } from '@mui/material';
import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt';
import WifiIcon from '@mui/icons-material/Wifi';
import BatteryFullIcon from '@mui/icons-material/BatteryFull';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import { COLORS } from './styles';

function StatusBar({ time = '06:42', battery = 87 }) {
  return (
    <Box sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      px: 1.25,
      py: 0.5,
      backgroundColor: '#000',
      borderBottom: `1px solid ${COLORS.divider}`,
      fontSize: '0.65rem',
    }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
        <QrCodeScannerIcon sx={{ fontSize: 12, color: COLORS.accent }} />
        <Typography sx={{ color: COLORS.textPrimary, fontSize: '0.65rem', fontWeight: 600 }}>
          {time}
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <SignalCellularAltIcon sx={{ fontSize: 11, color: COLORS.textPrimary }} />
        <WifiIcon sx={{ fontSize: 11, color: COLORS.textPrimary }} />
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25 }}>
          <BatteryFullIcon sx={{ fontSize: 12, color: COLORS.success }} />
          <Typography sx={{ color: COLORS.textPrimary, fontSize: '0.6rem' }}>{battery}%</Typography>
        </Box>
      </Box>
    </Box>
  );
}

export default StatusBar;
